import React, { Component } from 'react';
import { connect } from 'react-redux';

import LANGUAGES_CONTROLLER from '../../controllers/languages'
import ERROR_DOCUMENT_DETAIL_CONTROLLER from '../../controllers/errorDocumentDetail';
import ErrorDocumentDetailForm from './ErrorDocumentDetailForm';

import Logger, {LOG_LEVELS} from '../../utils/logger';
const log = new Logger('ERROR_DOCUMENT_DETAIL_PAGE', LOG_LEVELS.DEBUG);

class ErrorDocumentDetail extends Component {

  render() {
    log.debug('render(): ', this.props);

    return (
      <div>     
        <div className="clear"></div>
        <s-container className="mb50">
          <h1 className="mb20">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Title')}</h1>
           {
            this.props.errorDetail ? (
               <ErrorDocumentDetailForm
                 errorDetail={this.props.errorDetail}
                 submitHandler={this.doReprocessErrorDocument.bind(this)}
              />
              ) : (<div>{LANGUAGES_CONTROLLER.format(this.props.languages,'errorDocumentDetail_NoDetails')}</div>)
           }
        </s-container>
      </div>
    );
  }
  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    // errorId is set by the route definition using :errorId and then redux/react magic pagedDataFetch gets it here
    this.props.onPageLoad(this.props.match.params.errorId, this.props.featureFlags);
  }

  doReprocessErrorDocument(formData){
    // We have all the info we need here in formData to create the replaceTagVagValue
    log.debug('doReprocessError Page: formData: ', formData);

    // Send reference to the formData to the controller to work out what changed
    this.props.doReprocessError(formData);

    // TODO - Only do this, if doReprocessError was a success
    this.props.history.goBack()
  }
}

// Which props do we want to inject, given the global state?
// ../controllers/index.js adds the errorDetail to the global state 
// from the state returned by errorDocumentDetailActionHandler in 
// ../controllers/errorDocumentDetail
function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {
    languages: state.languages,
    errorDetail: state.errorDetail && state.errorDetail.data,
    featureFlags: state.featureFlag && state.featureFlag.data
  };
}

// The id comes from the componentWillMount (at line 38)
function mapDispatchersToProps(dispatch) {
  return {
    onPageLoad: (id, featureFlags = []) => {
      dispatch(ERROR_DOCUMENT_DETAIL_CONTROLLER.doLoad(id, () => {}, featureFlags));
    },
    doReprocessError: (formData) => {
      dispatch(ERROR_DOCUMENT_DETAIL_CONTROLLER.doReprocessError(formData));
    },
  }
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(ErrorDocumentDetail);
